import React, { useEffect, useState } from 'react'
import { LeadTreatment } from '../_LeadTreatment'
import { TreatmentFilterModel, TreatmentModel, TreatmentType } from '../models/superbit-api-models';
import TasksTable from '../tasks/_TasksTable';
import "../tasks/_tasks.css";
import { Dropdown, MenuProps, Spin } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { set } from 'lodash';
import { setDocumentLeadTaskUrl, setLeadIdForTreatment, setLeadTreatmentPopUp, setLeadTreatmentType, setPhoneNumberOfLead, setReloadLeadTreatments } from '../app-context/leadsSlice';
import { setCreateTreatmentFrom, setPopUpTreatmentModel, setTask, setTypeTreatmentsAction } from '../app-context/tasksSlice';
import { setEmailSubjectDetails } from '../app-context/leadsSlice';
import { CustomerCardModel } from '../models/CustomerCardModel';
import moment from 'moment';
import { RootState } from '../app-context/store';
import { LeadDocumentPopup } from './_LeadDocumentPopup';
import ConfirmPopUp from '../tasks/_ConfirmPopup';

interface leadTreatments {
    lead: any;
}

const LeadTreatments: React.FC<leadTreatments> = (props: leadTreatments) => {

    const dispatch = useDispatch();

    const customerCardModel = new CustomerCardModel();

    const [treatmentsList, setTreatmentsList] = useState<TreatmentModel[]>([]);
    const [loading, setLoading] = useState(false);

    const [treatmentsFilter, setTreatmentsFilter] = useState<any>({
        leadId: props.lead.lead.id,
        page: 1,
    })
    const [assignmentIdForDelete, setAssignmentIdForDelete] = useState<string | null>(null)
    const [showDeleteAssignmentPopUp, setShowDeleteAssignmentPopup] = useState<boolean>(false);




    const reloadLeadTreatments = useSelector((state: RootState) => state.leads.reloadLeadTreatments);


    useEffect(() => {
        console.log('useEffect-props.lead', props.lead.lead)


        getTreatments(treatmentsFilter as TreatmentFilterModel);
    }, [])

    useEffect(() => {
        if (reloadLeadTreatments) {
            getTreatments(treatmentsFilter as TreatmentFilterModel);
            dispatch(setReloadLeadTreatments(false));
        }
    }, [reloadLeadTreatments])




    const onAddOfferOptionClick = (type: number) => {
// 
        let treatmentSubject = '';
        treatmentSubject = `שם: ${props.lead.lead.firstName} ${props.lead.lead.lastName}, פרטי רכב: ${props.lead.lead.vehicle.licenseNumber != '' ? props.lead.lead.vehicle.licenseNumber : props.lead.lead.vehicle.vehicleSubModel.modelCode},`;
        if (type == TreatmentType._3) {
            dispatch(setTypeTreatmentsAction("new"));
        }
        console.log('onAddOfferOptionClick props.lead.lead', props.lead.lead)
        console.log('onAddOfferOptionClick treatmentSubject', treatmentSubject)
        //leadSlice
        dispatch(setLeadTreatmentPopUp(true));
        dispatch(setLeadTreatmentType(type));
        dispatch(setLeadIdForTreatment(props.lead.lead.id));
        dispatch(setEmailSubjectDetails(treatmentSubject)); // Reset email subject details


        dispatch(setCreateTreatmentFrom({ type: 'lead', id: props.lead.lead.id }));
        dispatch(setPhoneNumberOfLead(props.lead.lead.phoneNumber1));

    }


    const addOfferOptions: MenuProps['items'] = [
        // {
        //     key: '0',
        //     label: (
        //         <div className="pointer rtl"
        //             onClick={() => { onAddOfferOptionClick(TreatmentType._0) }}
        //         >
        //             תיעוד שיחה
        //         </div>
        //     ),
        // },
        // {
        //     key: '3',
        //     label:
        //         <div className="pointer rtl"
        //             onClick={() => { onAddOfferOptionClick(TreatmentType._3) }}
        //         >
        //             תיעוד דוא"ל
        //         </div>,
        // },
        {
            key: '4',
            label:
                <li className="pointer rtl"
                    onClick={() => { onAddOfferOptionClick(TreatmentType._4) }}
                >
                    תיעוד
                </li>,
        },
        // {
        //     key: '6',
        //     label:
        //         <li className="pointer rtl"
        //             onClick={() => { onAddOfferOptionClick(TreatmentType._6) }}
        //         >
        //             מכתב
        //         </li>,
        // },
        {
            key: '1',
            label:
                <li className="pointer rtl"
                    onClick={() => { onAddOfferOptionClick(TreatmentType._1) }}
                >
                    משימה
                </li>,
        },
        {
            key: '2',
            label:
                <li className="pointer rtl"
                    onClick={() => { onAddOfferOptionClick(TreatmentType._2) }}
                >
                    וואצפ
                </li>,
        },

    ];

    const emptyFunc = (t?: any, v?: any) => { }


    const getTreatments = async (filter?: TreatmentFilterModel) => {
        setLoading(true);
        setTreatmentsList([]);
        if (!filter) {
            filter = treatmentsFilter;
        }
        const treatmentsData = await customerCardModel.treatmentsFilter(filter as TreatmentFilterModel);
        const treatments: any[] = [];
        if (treatmentsData.items && treatmentsData.items.length > 0) {
            treatmentsData.items.forEach((item: any) => {
                if (item.treatmentActivities && item.treatmentActivities.length > 0) {
                    const lastActivity = item.treatmentActivities[item.treatmentActivities.length - 1];
                    if (lastActivity && lastActivity.createdById !== '') {
                        item.updatedBy = lastActivity.createdBy;
                        item.updatedById = lastActivity.createdById;
                    }
                }
                treatments.push(item);
            })
        }

        const treatmentsSorted = treatments.sort((a: any, b: any) => {
            const dateA = new Date(a.createdDate);
            const dateB = new Date(b.createdDate);
            // Sort by eventDate in descending order
            return dateB.getTime() > dateA.getTime() ? 1 : -1;
        });


        setTreatmentsList(treatmentsSorted);
        setLoading(false);
    }

    const editTask = async (id?: string) => {
        if (!id) {
            // if (leadIdForTreatment && leadIdForTreatment.length > 0) {
            //     let data = await customerCardModel.treatmentsForUpsert({ leadId: leadIdForTreatment, treatmentType: 1 });
            //     setSelectedAssigment(data);
            // }  else {
            let newTreatment =
            {
                "id": null,
                "createdDate": null,
                "eventDate": null,
                "alertDate": null,
                "treatmentType": 0,
                "topic": "",
                "note": "2",
                "filePath": null,
                "customerId": null,
                "customer": null,
                "from": "",
                "to": "",
                "cc": "",
                "bcc": "",
                "assignmentStatus": null,
                "policyRelatedId": null,
                "policyRelated": null,
                "sueRelatedId": null,
                "sueRelated": null,
                "leadRelatedId": null,
                "leadRelated": null,
                "relationEntitiesModel": null,
                "agentId": null,
                "agent": null,
                "userId": null,
                "user": null,
                "startDate": null,
                "endDate": null,
                "fileAttachment": null,
                "customersIds": null,
                "leadsIds": null,
                "companyId": null,
                "company": null,
                "priority": null,
                "treatmentOutcome": null,
                "emailDeliveryType": null,
                "address": null,
                "smsFrom": null,
                "smsTo": null,
                "smsMessage": null,
                "smsPhone": null,
                "smsSenderId": null,
                "faxPhone": null,
                "sentByFax": null,
                "faxBy": null,
                "faxInHonorOf": null,
                "statusChangeEmail": null,
                "statusChangeSms": null,
                "location": null,
                "includeLogo": false,
                "emailBody": "",
                // "emailBody": "KYUSHU PLUS 4X2 (1987) היברידי רגיל פנאי-שטח;;;<p><span style=\"font-size:16px\"><strong><u>ביטוח מסוג מקיף כולל כיסוי תאונה וגניבה </u></strong></span></p>\r\n\r\n<p><span style=\"font-size:16px\"><u>הביטוח כולל:</u></span></p>\r\n\r\n<ul dir=\"rtl\">\r\n\t<li><span style=\"font-size:16px\"><span style=\"font-family:Arial,Helvetica,sans-serif\">DynamicData3</span></span></li>\r\n\t<li><span style=\"font-size:16px\">התחייבות לתיקון בחלפים מקוריים במוסך מורשה לקסוס.</span></li>\r\n\t<li><span style=\"font-size:16px\">גרירה ושרותי דרך 24 שעות ביממה- ממסי בטלפון 5202*. (כולל החלפת גלגל, גרירה מכביש 6 ומחניונים)</span></li>\r\n\t<li><span style=\"font-size:16px\">החזר הוצאות נסיעה ממקום התאונה עד 250 שח , במידה והרכב אינו במצב נסיעה.</span></li>\r\n\t<li><span style=\"font-size:16px\">כיסוי שבר שמשות סטנדרטי (לא מקורי) ללא השתתפות עצמית</span></li>\r\n\t<li><span style=\"font-size:16px\">רכב חליפי לקסוס* : לנהגים מגיל 24 מעל שנה ותק נהיגה :&nbsp;בתאונה - רכב חליפי במוסך הסדר לקסוס &nbsp;מפתח תמורת מפתח.&nbsp;בגניבה או טוטאלוסט -30 יום או עד קבלת תשלום מחברת הביטוח (המוקדם מביניהם)</span></li>\r\n\t<li><span style=\"font-size:16px\">גבול אחריות לפגיעה בצד ג&#39; 1,500,000 ₪</span></li>\r\n\t<li><span style=\"font-size:16px\">כינון אוטומט במוסך הסדר - ללא תוספת פרמיה.</span></li>\r\n\t<li><span style=\"font-size:16px\">הרכב יחשב לאובדן כללי בנזק מעל 50% בלבד.</span></li>\r\n\t<li><span style=\"font-size:16px\">השתתפות עצמית במוסכי הסדר לקסוס :&nbsp;לרכב בשווי עד 350000 שח &nbsp;1390 ₪ , לנהגים עד גיל 21 &nbsp;)לא חדשים) 2092 ש&quot;ח, לנהגים מגיל 17 או לנהגים חדשים 2794 ₪ &#39;&nbsp;&nbsp;לרכב בשווי מעל 350000 שח : 2000 ₪ , &nbsp; &nbsp; לנהגים 17+ או נהגים חדשים 3000 ₪ .</span></li>\r\n\t<li dir=\"RTL\" style=\"text-align:right\"><span style=\"font-size:16px\"><span style=\"font-family:&quot;Times New Roman&quot;,&quot;serif&quot;\"><span style=\"font-family:&quot;Arial&quot;,&quot;sans-serif&quot;\">השתתפות עצמית בירידת ערך 1.5%</span><span dir=\"LTR\" style=\"font-family:&quot;Arial&quot;,&quot;sans-serif&quot;\">.</span><span style=\"font-family:&quot;Arial&quot;,&quot;sans-serif&quot;\"> ברכבים בשווי מעל 350000 שח- השתתפות עצמית בירידת ערך 5%.</span></span></span></li>\r\n\t<li><span style=\"font-size:16px\">הגנה משפטית עד 50,000 ₪. ה&quot;ע 200 ₪</span></li>\r\n\t<li><span style=\"font-size:16px\">ביטוח תוספות ואבזור ברכב עד 10,000 ₪ ללא תוספת פרמיה בכפוף להצגת חשבונית בגין האביזרים טרם עריכת הביטוח .</span></li>\r\n\t<li><span style=\"font-size:16px\">שירות VIP ללקוחות הקולקטיב 24 שעות ביממה בטלפון 8099*.</span></li>\r\n\t<li><span style=\"font-size:16px\"><span style=\"font-family:Arial,Helvetica,sans-serif\">DynamicData1</span></span></li>\r\n\t<li><span style=\"font-size:16px\"><span style=\"font-family:Arial,Helvetica,sans-serif\">DynamicData2</span></span></li>\r\n</ul>\r\n\r\n<p dir=\"RTL\"><span style=\"font-size:16px\">*רכב חליפי לקסוס או לחילופין רכב מנהלים&nbsp;על בסיס&nbsp;&nbsp;זמינות המשכיר.</span></p>\r\n\r\n<p>&nbsp;</p>\r\n;;;<p dir=\"RTL\"><span style=\"font-size:14px\"><strong><u>הביטוח מותנה וכפוף</u></strong><strong><u>:</u></strong></span></p>\r\n\r\n<ul>\r\n\t<li dir=\"RTL\"><span style=\"font-size:14px\">באישור העדר תביעות ביטוח מקיף 3 שנים אחרונות &ndash; יש להציג אישור תוך 7 ימים.</span></li>\r\n\t<li dir=\"RTL\"><span style=\"font-size:14px\">אישור בדיקת מיגון הנדרש ע&quot;י חברת הביטוח.</span></li>\r\n\t<li dir=\"RTL\"><span style=\"font-size:14px\">כל הכיסויים בכפוף לתנאי הפוליסה ולכתבי השירות הרלוונטיים.</span></li>\r\n\t<li dir=\"RTL\"><span style=\"font-size:14px\">את הביטוח מקיף ניתן לחלק ב-4 תש&#39; ללא ריבית וחובה ב-12 תש&#39; ללא ריבית.</span></li>\r\n\t<li dir=\"RTL\"><span style=\"font-size:14px\">חלק מהכיסויים נמכרים ללא מעורבות חב&#39; הביטוח והנם באחריות מלאה של נותני השירות .</span></li>\r\n\t<li dir=\"RTL\"><span style=\"font-size:14px\">ט.ל.ח</span></li>\r\n</ul>\r\n",
                "includeCustomerInfo": false,
                "isFullDay": false,
                "forTreatmentById": null,
                "forTreatmentBy": null,
                "belongsToId": null,
                "belongsTo": null,
                "employer": null,
                "employerId": null,
                "riderId": null,
                "rider": null,
                "status": null,
                "assignmentStatusType": 0,
                "whatsAppMessageId": null,
                "treatmentActivities": [],
                "treatmentTypeIcon": "fa-mobile-alt",
                "upsertActionName": "UpsertSmsTreatment",
                "FileAttachments": [],
                "seen": false
            }
            console.log('newTreatment', newTreatment);
            dispatch(setTask(newTreatment));
            // }
        } else {
            const data = await customerCardModel.getAssignment(id);
            await customerCardModel.setAssignmentSeen(id);

            console.log('data getAssignment', id, data)

            // for updating the seen status in the list
            if (treatmentsList) {
                const taskIndex = treatmentsList.findIndex((t: any) => t.id == id);
                if (taskIndex > -1) {
                    treatmentsList[taskIndex].seen = true;
                    setTreatmentsList(treatmentsList);
                }
            }

            if (data.endDate == '0001-01-01T00:00:00') {
                data.endDate = moment().format('YYYY-MM-DDTHH:ss');
            }
            // set data to redux store for use in the popup
            console.log('data', data);
            dispatch(setTask(data));
            dispatch(setLeadTreatmentPopUp(true));
            dispatch(setLeadTreatmentType(1));
            dispatch(setPopUpTreatmentModel({ show: true, type: 1 }));


            // setSelectedAssigment(data);
        }
        // setShowAddTreatmentPopup(true)
    }

    const editEmail = async (id: string) => {
        await customerCardModel.setAssignmentSeen(id);
        if (treatmentsList) {
            const taskIndex = treatmentsList.findIndex((t: any) => t.id == id);
            treatmentsList[taskIndex].seen = true;
            setTreatmentsList(treatmentsList);
        }
        dispatch(setPopUpTreatmentModel({ show: true, type: 3 }));
        dispatch(setLeadTreatmentType(3));
        dispatch(setLeadTreatmentPopUp(true));

    }

    const editReferrence = async (id: string) => {
        dispatch(setLeadIdForTreatment(props.lead.lead.id));
    }

    const editDoc = async (id: string) => {
        await customerCardModel.setAssignmentSeen(id);
        if (treatmentsList) {
            const taskIndex = treatmentsList.findIndex((t: any) => t.id == id);
            if (taskIndex > -1) {
                treatmentsList[taskIndex].seen = true;
                setTreatmentsList(treatmentsList);
            }
        }
        dispatch(setLeadIdForTreatment(props.lead.lead.id));
        dispatch(setPopUpTreatmentModel({ show: true, type: 4 }));
        dispatch(setLeadTreatmentType(4));
        dispatch(setLeadTreatmentPopUp(true));

    }


    const setStatus = (id: string, status: string) => {
        customerCardModel.setAssignmentStatus(id, status).then((res: any) => {
            customerCardModel.setAssignmentSeen(id).then((res: any) => {
                if (treatmentsList) {
                    const taskIndex = treatmentsList.findIndex((t: any) => t.id == id);
                    treatmentsList[taskIndex].seen = true;
                    setTreatmentsList(treatmentsList);
                }
                getTreatments(treatmentsFilter as TreatmentFilterModel);
            })

            //set function to get updates data
        })
    }


    const deleteAssigment = (id: string) => {
        // console.log('deleteAssigment');
        // if(props.actions && props.actions.delete) {
        //     props.actions.delete(id);
        // }
        console.log('deleteAssigmentid', id)
        if (id && id != '') {
            setAssignmentIdForDelete(id);
            setShowDeleteAssignmentPopup(true);
        }
    }

    const onApproveDeleteAssignment = async (id: string) => {
        // setLoading(true)
        await customerCardModel.deleteAssigment(id);
        setAssignmentIdForDelete(null);
        setShowDeleteAssignmentPopup(false);
        console.log('onApproveDeleteAssignment', id)
        // setLoading(false);
        getTreatments();

        // setPopupMessageContent('המשימה נמחקה בהצלחה');
        // setPopupMessageTitle('מחיקת משימה');
    }

    const hideDeleteAssingmentPopup = () => {
        setShowDeleteAssignmentPopup(false)
    }

    const hasPermission = () => {
        const loggedUser = localStorage.getItem('loggedUser');
        if (loggedUser) {
            const user = JSON.parse(loggedUser);
            if (user) {
                if ([1, 2, 3, 4, 5, 13, 14, 15, 16].includes(user.role)) {
                    return false;
                }
            }
        }
        return true;
    }

    const clearTreatmentsLeadFliter = () => {
        getTreatments();
    }


    return (
        <>

            {hasPermission() &&
                <div className="details-row no-padding">
                    <div style={{ display: 'flex' }} className="flex-space-between">
                        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                            <div className="row-title">
                                טיפול שוטף
                            </div>
                            <div className="filter-button">
                                <div className="icon refresh-counter pointer" onClick={clearTreatmentsLeadFliter}></div>
                            </div>
                        </div>
                        <div className='flex-centered' style={{ marginLeft: "10px" }}>
                            <Dropdown menu={{ items: addOfferOptions }}>
                                <button type="button" className="button blue has-icon flex-centered flex-justify-center">
                                    <div className="icon add"></div>
                                    הוסף טיפול
                                </button>
                            </Dropdown>

                        </div>
                    </div>


                    {/*  <div className="content-table-header flex-centered flex-space-between">
                <div className="cell status date flex-centered flex-space-between">
                    תאריך אירוע
                    <div className="icon sort"></div>
                </div>
                <div className="cell">
                    סוג
                </div>
                <div className="cell text-label">
                    נושא
                </div>
                <div className="cell long">
                    הערות
                </div>
                <div className="cell actions">

                </div>
            </div>
            {props.lead != null && props.lead.lead != null && props.lead.lead != null && props.lead.lead.treatments != null ? props.lead.lead.treatments.map((treatment: TreatmentModel, index: number) => {
                return (
                    <>
                        <LeadTreatment treatment={treatment} key={index} />
                    </>
                )
            }) : ""} */}

                    {loading && <div className="loading">
                        <div className="loading-text">טוען...</div>
                        <Spin size="large" />
                    </div>
                    }

                    {/* {props.lead != null && props.lead.lead != null && props.lead.lead != null && props.lead.lead.treatments != null ? (
                <TasksTable data={props.lead.lead.treatments} fromLeads={true} */}

                    {!loading && treatmentsList != null ? (
                        <TasksTable data={treatmentsList} fromLeads={true}

                            actions={{
                                edit: (id: string) => editTask(id),
                                editEmail: (id: string) => editEmail(id),
                                editDoc: (id: string) => editDoc(id),
                                editReferrence: (id: string) => editReferrence(id),
                                sendWhatsApp: (id: string) => emptyFunc(),
                                print: (id: string) => emptyFunc(),
                                setStatus: (id: string, newStatus: string) => setStatus(id, newStatus),
                                delete: (id: string) => deleteAssigment(id),
                                onSortChange: (id: string) => emptyFunc(),
                                onShowDocument: (url: any[]) => dispatch(setDocumentLeadTaskUrl(url)),
                                // redirectToClient: (id: string) => redirectToClient(id),
                                updateSeen: (id: string) => emptyFunc(),
                            }}
                        />
                    ) : (<></>)}

                    {
                        showDeleteAssignmentPopUp && <ConfirmPopUp
                            data={assignmentIdForDelete}
                            messageTitle={'מחיקת משימה'}
                            message={'האם את/ה בטוח?'}
                            OnApprove={onApproveDeleteAssignment}
                            ClosePopup={hideDeleteAssingmentPopup}
                            fromLeadTreatments={true} />
                    }



                </div>
            }
        </>
    )
}

export default LeadTreatments;
